import moment from "moment";

export default function(date: Date | null | undefined, emptyText = ""): string {
  if (!date) {
    return emptyText;
  }
  return moment(date, "YYYY-MM-DD HH:mm").format("YYYY년 MM월 DD일");
}
